// extracted by mini-css-extract-plugin
export default {"tableWrap":"WasteTable_tableWrap__9Tx7k","tableHeader":"WasteTable_tableHeader__nu4Go"};